// extracted by mini-css-extract-plugin
export default {"container":"RedirectBtn_container__MGIdU","box":"RedirectBtn_box__wR1uQ","title":"RedirectBtn_title__49-zv","subtitle":"RedirectBtn_subtitle__1fuJm","icon":"RedirectBtn_icon__F0j5i"};